import React, { useEffect, useState } from 'react'
import { ContentHouse, ContentHouseProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import utils from 'features/contentHouse/contentHouse-util'
import validations from 'features/contentHouse/contentHouse-validation'
import * as modelProps from 'models/contentHouse/contentHouse-property-definitions';

export interface ContentHouseProps {
    BuildList?: (
        page: any,
        name: ContentHouseProperties,
        form: ContentHouse,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: ContentHouse
    onUpdate?: (form: ContentHouse, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function ContentHouseForm(props: ContentHouseProps) {
    let [form, setForm] = useState({} as ContentHouse)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as ContentHouse)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as ContentHouse)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<ContentHouse, ContentHouseProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.ContentHouseProperties.Id,
                modelProps.ContentHouseProperties.Deleted,
                modelProps.ContentHouseProperties.Version,
                modelProps.ContentHouseProperties.Created,
                modelProps.ContentHouseProperties.Updated,
                modelProps.ContentHouseProperties.Owner,
                modelProps.ContentHouseProperties.State,
                modelProps.ContentHouseProperties.Members,
            ].includes(x.name))
        },
        BuildList: (page, name: ContentHouseProperties, form: ContentHouse) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: ContentHouse,
            property: ContentHouseProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: ContentHouseProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<ContentHouse, ContentHouseProperties>(args)}
        </React.Fragment>
    )
}
